export default __webpack_public_path__ + "images/S7.9525b25.png";